import React from 'react';
import sty from 'styled-components';
import { Link } from 'react-router-dom';
import Back from '@material-ui/icons/ArrowBackRounded'
import Container from '../../components/Container';
import Add from '../../components/Add';
import m from '../../services/media';

export default function (p) {
  const post = p.location.state.post;
  var description = post.snippet.description.replace("Curta nossa página: https://www.facebook.com/atibaiatv", "");
    var title = post.snippet.title
    var date = new Date(post.snippet.publishedAt);
    if(date === new Date()){
      date = `Hoje ${date.getHours()}h${date.getMinutes()}`
    } else {
      date = `${date.getDay()<10?'0'+date.getDay():date.getDate()}/${date.getMonth()+1<10?'0'+(date.getMonth()+1):(date.getMonth()+1)} ${date.getHours()}h${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`
    }
    var posts = p.location.state.posts
    posts.splice(p.location.state.index, 1)
  return (
    <Container back history={p.history}>
      <VideoContainer>
        <Video>
          <FrameContainer>
            <Frame src={"https://www.youtube.com/embed/"+p.match.params.id+'?autoplay=1'} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen >
            </Frame>
          </FrameContainer>
          <AddSty forceLarge/>
        </Video>
        <PostDescription>
          <PostTitle>
            {title}
          </PostTitle>
          <PostText>
              {description.slice(0,100)}
          </PostText>
          <PostDate>
            {date}
          </PostDate>
        </PostDescription>
      </VideoContainer>
      <Next>
      <NextTitle style={{alignSelf: 'center', marginLeft: '1rem', marginTop: '3rem'}}>
        Recentes
      </NextTitle>
      {
        posts.map((post,key)=>{
          var description = post.snippet.description.replace("Curta nossa página: https://www.facebook.com/atibaiatv", "");
          var title = post.snippet.title
          var date = new Date(post.snippet.publishedAt);
          if(date === new Date()){
            date = `Hoje ${date.getHours()}h${date.getMinutes()}`
          } else {
            date = `${date.getDay()<10?'0'+date.getDay():date.getDate()}/${date.getMonth()+1<10?'0'+(date.getMonth()+1):(date.getMonth()+1)} ${date.getHours()}h${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`
          }
          return <PostContainer key={key} onClick={()=>window.scrollTo(500, 0)} to={{pathname: '/video/'+post.contentDetails.videoId, state: {post: post, index: key, posts: posts}}}>
          <PostImgContainer>
            <PostImg src={post.snippet.thumbnails.high.url || post.snippet.thumbnails.default.url } />
          </PostImgContainer>
          <PostDescription>
            <PostTitle>
              {title}
            </PostTitle>
            <PostText>
                {description.slice(0,100)}
            </PostText>
            <PostDate>
              {date}
            </PostDate>
          </PostDescription>
        </PostContainer>
        })
      }
      </Next>
    </Container>
  );
}


const VideoContainer = sty.div`
  flex-direction: column;
  align-self: center;
`
const Video = sty.div`
display: block;
padding-top: 4rem;
width: 100vw;
max-width: 50rem
flex-direction: column;
overflow-y: scroll;
`
const FrameContainer = sty.div`
flex: 0 0 100%;
align-self: center;
max-width: 60rem
height: 0;
position: relative;
padding-top: 56.25%;
overflow: hidden;
box-shadow: 0 .1rem .3rem #888a;
${m.sm`
`};
${m.md`
  border-radius: 1rem 1rem 0rem 0rem;
  margin: 0 1rem;
`};
${m.lg`
  border-radius: 1rem 1rem 0rem 0rem;
  margin: 0 1rem;
`};
`
const Frame = sty.iframe`
position: absolute;
width: 100%;
height: 100%;
left: 0;
top: 0;
border: none;
`

const Next = sty.div`
  flex-direction column;
  align-items: center;
`

const AddSty = sty(Add)`
  ${m.sm`
    border-radius: 0;
  `};
  ${m.md`
    width: calc(100% - 2rem);
    margin: 0 1rem;
    border-radius: 0 0  1rem 1rem;
  `};
  ${m.lg`
    width: calc(100% - 2rem);
    margin: 0 1rem;
    border-radius: 0 0  1rem 1rem;
  `};
`
const PostDescription = sty.div`
  padding: .3rem .7rem .7rem .7rem;
  flex-direction: column;
`
const PostTitle = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: 500;
  overflow: hidden;
  margin: .5rem .5rem;
  padding: .5rem 0 0 0;
  position: relative;
  flex: 1 0;
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1.5em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostText = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: .8rem;
  line-height: 1rem;
  font-weight: 400;
  max-height: 3rem;
  margin: 0 .5rem;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 0;
  -webkit-line-clamp: ellipsis
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1rem;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostDate = sty.p`
  margin: .5rem .5rem .5rem .5rem;
`
const PostContainer = sty(Link)`
  flex-direction: column;
  width: 100%;
  max-width: 50rem
`
const PostImgContainer = sty.div`
  display: block;
  position: relative;
  overflow: hidden;
  padding: calc(55% - .5rem) 0 0 0;
  box-shadow: 0 .1rem .3rem #888a;\
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 .1rem .3rem #888;
  }
  ${m.sm`
    width: 100%
    margin: .5rem 0rem 0 0rem;
    border-radius: 0;
    &:hover {
      transform: scale(1);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  ${m.md`
    width: calc(100% - 2rem);
    margin: .5rem 1rem 0 1rem;
    border-radius: .5rem;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  ${m.lg`
    width: calc(100% - 2rem);
    margin: .5rem 1rem 0 1rem;
    border-radius: .5rem;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  
`
const PostImg = sty.img`
  display: block;
  width: 100%;
  position: absolute;
  top: -17.5%;
  left: 0;
  object-fit: cover;
`

const NextTitle = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: 500;
  overflow: hidden;
  margin: .5rem .5rem;
  padding: .5rem 0 0 0;
  position: relative;
  flex: 1 0;
`